import { TagProps } from "antd"

export const getTourRatingColor = (rate: number): 'green' | 'warning' | 'error' => {
  if (rate > 8) {
    return 'green'
  } else if (rate > 5) {
    return 'warning'
  } else {
    return 'error'
  }
}